import clsx from 'clsx';
import React from 'react';
import 'assets/scss/timeline.scss';
export const TimelineItem = props => {
    const { step, cssClass: cssClass, block, title, index, steps = [], number, clickable = false, onClick, alwaysShowSteps = false } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx('timeline-block', cssClass, {
                active: block === index,
                passed: block > index,
                disabled: block < index,
                alone: steps.length === 0,
            }) },
            React.createElement("div", { className: 'timeline-ico' },
                React.createElement("span", { className: 'number' }, number !== null && number !== void 0 ? number : index + 1)),
            React.createElement("div", { className: 'timeline-content' },
                React.createElement("div", { className: 'timeline-content-inner' },
                    React.createElement("h2", { className: clsx({
                            'cursor-pointer': clickable,
                        }), onClick: () => clickable && onClick && onClick() }, title))))));
};
